import { useEffect, useState } from 'react';

const hasRealMeals = (meals) => meals && typeof meals === 'object' && Object.keys(meals).length > 0;

const sortMealsByTime = (meals) => {
    const toMinutes = (time) => {
        if (!time) return Infinity;

        const [h, m] = time.split(':').map(Number);
        return h * 60 + m;
    };

    return [...meals].sort((a, b) => {
        return toMinutes(a?.time) - toMinutes(b?.time);
    });
};

const applyDisplayIndex = (meals) => {
    const sorted = sortMealsByTime(meals);

    return sorted.map((meal, index) => ({
        ...meal,
        _displayIndex: index + 1
    }));
};

const normalizeMeals = (mealsByType) =>
    Object.fromEntries(Object.entries(mealsByType).map(([type, meals]) => [type, applyDisplayIndex(meals)]));

const useDiaryMeals = (initialMeals = null) => {
    const [meals, setMeals] = useState({});

    // HYDRATE FROM INITIAL
    useEffect(() => {
        if (!hasRealMeals(initialMeals)) return;

        setMeals((prev) => {
            const normalized = normalizeMeals(initialMeals);

            // SHALLOW COMPARE
            if (JSON.stringify(prev) === JSON.stringify(normalized)) return prev;

            return normalized;
        });
    }, [initialMeals]);

    const addMeal = (newItems, type) => {
        const items = Array.isArray(newItems) ? newItems : [newItems];

        setMeals((prev) =>
            normalizeMeals({
                ...prev,
                [type]: [...(prev[type] || []), ...items]
            })
        );
    };

    const deletePlaceholder = (type, displayIndex) => {
        setMeals((prev) =>
            normalizeMeals({
                ...prev,
                [type]: prev[type]?.filter((m) => m._displayIndex !== displayIndex)
            })
        );
    };

    return { meals, addMeal, deletePlaceholder };
};

export default useDiaryMeals;
